import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './ScenarioScreen.module.scss';
import classNames from 'classnames';
import FactBlock from './FactBlock';
import QuestionBlock from './QuestionBlock';
import {playAudio} from './mediaBundle';

export default class ScenarioScreen extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onChangeGame: PropTypes.func.isRequired,
    };

    componentDidUpdate(prevProps) {
        if (
            !prevProps.game.userChoice.rightFactSelected &&
            this.props.game.userChoice.rightFactSelected
        ) {
            playAudio('transition');
        }
    }

    render() {
        const {game} = this.props;
        const {scenario, userChoice} = game;

        const userRightFactSelected = userChoice.rightFactSelected;

        const mainBlockClassName = classNames(styles.mainBlock, {
            [styles.mainBlockWithSpace]: userRightFactSelected,
        });

        return (
            <section className={styles.scenarioScreen}>
                <div className={styles.backButton} onClick={this.clearScenario}>
                    <div className={styles.backButtonText}>Menu</div>
                </div>

                <main className={mainBlockClassName}>
                    <FactBlock game={game} onUpdateUserChoice={this.updateUserChoice} />

                    <div className={styles.spacer} />

                    {userRightFactSelected && (
                        <QuestionBlock
                            game={game}
                            onUpdateUserChoice={this.updateUserChoice}
                            onFinishScenario={this.finishScenario}
                        />
                    )}
                </main>
            </section>
        );
    }

    updateUserChoice = userChoiceChanges => {
        const {game} = this.props;
        const {userChoice} = game;

        this.props.onChangeGame({
            ...game,
            userChoice: {
                ...userChoice,
                ...userChoiceChanges,
            },
        });
    };

    clearScenario = () => {
        const {game} = this.props;

        playAudio('button');

        this.props.onChangeGame({
            ...game,
            scenario: null,
        });
    };

    finishScenario = () => {
        const {game} = this.props;

        playAudio('finishScenario');

        this.props.onChangeGame({
            ...game,
            finishedScenarios: [...game.finishedScenarios, game.scenarioIndex],
            scenario: null,
        });
    };
}
